import { apiInstance } from 'api/utils';

export default {
  getCapacityForLossConfig: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/settings/capacity-for-loss/'
    });
  },
  updateCapacityForLossConfig: (data: number[]) => {
    return apiInstance.request({
      method: 'POST',
      url: '/settings/capacity-for-loss/',
      data: {
        capacity_for_loss_toggles: data
      }
    });
  },
  getCapacityForLossResponses: ({ portfolio }: { portfolio: any }) => {
    return apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/capacity-for-loss/`
    });
  },
  submitCapacityForLossResponses: ({
    portfolio,
    responses
  }: {
    portfolio: any;
    responses: any;
  }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/capacity-for-loss/`,
      data: responses
    });
  },
  getExperienceResponses: ({ portfolio }: { portfolio: any }) => {
    return apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/experience-questions/`
    });
  },
  submitExperienceResponses: ({
    portfolio,
    responses
  }: {
    portfolio: any;
    responses: any;
  }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/experience-questions/`,
      data: responses
    });
  }
};
